<template>
  <div class="station tableStyle">
    <el-row>
      <el-col :span="24">
        <query
          :formData="formData"
          :formList="formList"
          @reset="resetQuery"
          @query="query"
          @clear="query"
        ></query>
      </el-col>
    </el-row>

    <div class="tableArea">
      <el-table :data="tableData" class="table-border" height="100%">
        <el-table-column
            type="index"
            label="序号"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="code"
            label="电桩编号"
            align="center"
            width="120"
        ></el-table-column>
        <el-table-column
            prop="pile_group.name"
            label="所属桩群"
        ></el-table-column>
        <el-table-column
            prop="company.name"
            label="所属厂商"
        ></el-table-column>
        <el-table-column
            prop="updated_at"
            label="充电站地址">
            <template slot-scope="scope">
              {{stationAddress(scope.row)}}
            </template>
        </el-table-column>
        <!-- <el-table-column
            prop=""
            label="是否在线"
        ></el-table-column> -->
        <el-table-column
            prop="updated_at"
            label="最后连接时间"
            align="center"
            width="160"
        ></el-table-column>
        <el-table-column prop="status" label="状态" align="center" width="80">
            <template slot-scope="scope">
                {{scope.row.status === 1 ? '正常' : '故障'}}
            </template>
        </el-table-column>
      </el-table>
    </div>

    <el-row class="pageFoot">
      <el-col :span="12">
        <div class="statistical">
          统计：桩群数量（{{stationGroupTotal}}）个 &nbsp;&nbsp;&nbsp;&nbsp;充电桩数量（{{total}}）个
        </div>
      </el-col>
      <el-col :span="12">
        <el-pagination
          layout="total, prev, pager, next, sizes"
          background
          :page-size="size"
          :total="total"
          :page-sizes="[20,50,100,200,500,1000]"
          @size-change="sizeChange"
          @current-change="changePage"
        >
        </el-pagination>
      </el-col>
    </el-row>

  </div>
</template>
<script>
import Query from "components/query.vue";
export default {
  data() {
    return {
        size: 20,
        page: 1,
        total: 0,
        formData: {
          code: '',
          pile_group_id: '',
          company_id: '',
          status: '',
          online: '',
        },
        formList: [
            {
                type: "input",
                label: "电桩编号",
                placeholder: "请输入电桩编号",
                model: "code",
            },
            {
                type: "select",
                label: "所属桩群",
                placeholder: "请选择所属桩群",
                model: "pile_group_id",
                labelName: 'name',
                valueName: 'id',
                optionList: []
            },
            {
                type: "select",
                label: "厂商名称",
                placeholder: "请选择厂商",
                model: "company_id",
                labelName: 'name',
                valueName: 'id',
                optionList: []
            },
            // {
            //     type: "select",
            //     label: "在线状态",
            //     placeholder: "全部",
            //     model: "online",
            //     labelName: 'name',
            //     valueName: 'id',
            //     optionList: [
            //         {
            //             id: 0,
            //             name: '离线',
            //         },
            //         {
            //             id: 1,
            //             name: '在线'
            //         }
            //     ]
            // },
            {
                type: "select",
                label: "状态",
                placeholder: "全部",
                model: "status",
                labelName: 'name',
                valueName: 'id',
                optionList: [
                    {
                        id: 0,
                        name: '故障',
                    },
                    {
                        id: 1,
                        name: '正常'
                    }
                ]
            },
        ],

        tableData: [],
        stationGroupTotal: 0,

        allManufacturer: [],
        allStation: [],
    };
  },
  components: {
    Query,
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
        this.getTableList();
        this.getAllManufacturer();
        this.getAllStationGroup();
    },
    // 获取table
    getTableList(data){
        let params = {};
        if (data) {
            params = data;
        }
        params.page = this.page;
        params.size = this.size;
        this.$http.get(this.common.admin + "/admin/pileList", {
            params: params,
        }).then((res) => {
            if (res.code === 200) {
                this.total = res.data.total;
                this.tableData = res.data.list;
                this.stationGroupTotal = res.data.pile_group_count;
            } else {
                this.$message.error(res.msg);
            }
        });
    },
    // 获取所有厂商列表
    getAllManufacturer(){
      this.$http.get(this.common.admin+'/admin/companyAllList').then(res => {
        if(res.code === 200){
          this.allManufacturer = res.data;
          for(let i of this.formList){
            if(i.label === '厂商名称'){
              i.optionList = res.data;
            }
          }
        }else{
          this.$message.error(res.msg);
        }
      });
    },
    // 获取所有桩群
    getAllStationGroup(){
        this.$http.get(this.common.admin + '/admin/pileGroupAllList').then(res => {
            if(res.code === 200){
              this.allStation = res.data;
                for(let i of this.formList){
                    if(i.label === '所属桩群'){
                        i.optionList = res.data;
                    }
                }
            }else{
                return this.$message.error(res.msg);
            }
        });
    },
    // 查询
    query(data) {
      this.page = 1;
      this.getTableList(data);
    },
    // 重置查询条件
    resetQuery() {
      this.page = 1;
      this.formData = {
        code: '',
        pile_group_id: '',
        company_id: '',
        status: '',
        online: '',
      };
      this.getTableList();
    },
    // 拼接电桩地址
    stationAddress(data){
      let address = '';
      if(data.pile_group != null){
        address = data.pile_group.province_name + data.pile_group.city_name + data.pile_group.area_name + data.pile_group.address;
      }else{
        address = '';
      }
      return address;
    },
    // 翻页
    changePage(page) {
      this.page = page;
      this.getTableList(this.formData);
    },
    // 修改每页条数
    sizeChange(val){
      this.size = val;
      this.getTableList(this.formData);
    }
  },
};
</script>
<style lang="less" scoped>
.station {
  height: 100%;
  display: flex;
  flex-direction: column;
  .tableArea{
    flex: 1;
    min-height: calc(100% - 205px);
  }
  .dialogRadius{
    .tipsBox{
      /deep/.el-form-item__content{
        line-height: 1;
        .tips{
          font-size: 14px;
          color: #c0c4cc;
        }
      }
    }
  }

  .pageFoot{
    .statistical{
      font-size: 14px;
    }
  }
}
</style>